export enum StrategyType {

}

export enum ExpiryType {

}

export enum InstrumentType {

}

export enum OrderMode {

}

export enum StrikeSelection {

}

export enum PortfolioProductType {
    BOTH = 0,
    INTRADAY = 1,
    CARRYFORWARD = 2
}

export const ProductTypeMap = {
    [PortfolioProductType.BOTH]: 'All',
    [PortfolioProductType.INTRADAY]: 'Intraday',
    [PortfolioProductType.CARRYFORWARD]: 'Carryforward'
}

export enum shareSearchType {
    clientSearch = 0,
    portfolioSearch = 1
}

export enum formBuilderType {
    OPTIONS = 0,
    EQUITIES = 1
}
